// extracted by mini-css-extract-plugin
module.exports = {"more":"pages-sponsorships-modals-previewNotificationList__more--3rL47"};